import React from "react";
import "./Projects.css";

const GameSelect = ({
    games = [],
    loading,
    error,
    onSelect,
    onBack
}) => {

    return (
        <div className="projects-screen">

            <div className="projects-topbar">
                <button
                    type="button"
                    className="back-button"
                    onClick={onBack}
                >
                    ← Back
                </button>
            </div>

            <div className="projects-header">
                <h1>Choose Your Game</h1>
                <p>
                    Select the space robotics game
                    you want to work on.
                </p>
            </div>

            {loading && (
                <div className="projects-message">
                    Loading games...
                </div>
            )}

            {error && (
                <div className="projects-error">
                    {error}
                </div>
            )}

            {!loading &&
                !error &&
                games.length === 0 && (
                    <div className="projects-message">
                        No games are available.
                    </div>
                )}

            {!loading &&
                !error &&
                games.length > 0 && (

                <div className="project-choice-grid">

                    {games.map((game) => (
                        <button
                            key={game.id}
                            type="button"
                            className="project-choice-card"
                            onClick={() =>
                                onSelect(game.id)
                            }
                        >
                            <div className="project-choice-icon">
                                ◇
                            </div>

                            <div className="project-choice-content">
                                <h2>{game.name}</h2>

                                <p>
                                    {game.description ||
                                        "Space robotics project"}
                                </p>
                            </div>

                            <div className="project-choice-arrow">
                                →
                            </div>
                        </button>
                    ))}

                </div>
            )}

        </div>
    );
};

export default GameSelect;